import { render, staticRenderFns } from "./OfferRevenue.vue?vue&type=template&id=473fab58&scoped=true"
import script from "./OfferRevenue.vue?vue&type=script&lang=js"
export * from "./OfferRevenue.vue?vue&type=script&lang=js"
import style0 from "./OfferRevenue.vue?vue&type=style&index=0&id=473fab58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473fab58",
  null
  
)

export default component.exports